/**
 * Global keyboard shortcuts (P2.1-S4).
 *
 * - Cmd/Ctrl+K: toggle Command Palette
 * - Esc: close palette (handled inside palette component itself)
 *
 * Mount once ở App-root level. Ignore khi user đang gõ trong text input
 * (trừ Cmd+K vẫn hoạt động vì user có thể muốn quick-jump giữa typing).
 */
import * as React from "react";

import { useCommandPaletteStore } from "@/stores/commandPalette";
import { useOnboardingStore } from "@/stores/onboarding";

export function useGlobalShortcuts(): void {
  const togglePalette = useCommandPaletteStore((s) => s.togglePalette);
  const toggleHelp = useOnboardingStore((s) => s.toggleHelp);

  React.useEffect(() => {
    const handler = (e: KeyboardEvent): void => {
      const ctrlOrCmd = e.metaKey || e.ctrlKey;
      if (!ctrlOrCmd) return;
      const key = e.key.toLowerCase();
      // Cmd/Ctrl+K — Command Palette (P2.1-S4)
      if (key === "k") {
        e.preventDefault();
        togglePalette();
        return;
      }
      // Cmd/Ctrl+/ — Help Drawer (P2.1-S6)
      if (key === "/") {
        e.preventDefault();
        toggleHelp();
        return;
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [togglePalette, toggleHelp]);
}
